function factory({ window, document, thn }) {
    const engine = {};
    /**
         * @memberOf module:bs_1046132
         * @see {@link on_state_change}
         *
         * @param {object} ctx - The context object.
         */
    engine.onStateChange = thn.debounce(thn.pageCheck, 500);
    /**
         * @memberOf module:bs_1046132
         * @see {@link language_check}
         *
         * @param {object} ctx - The context object.
         */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const lang = document.documentElement.lang;
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    return engine;
}

export { factory };
